module.exports = __webpack_public_path__ + "img/build.b5118652.png";